import highlightText from './highlightText';

export function selectId(item, index) {
  return index;
}

export function selectLabel(item, extraOptions) {
  let rawLabel = null;
  if (extraOptions && extraOptions.display && extraOptions.display.values) {
    const displayValues = extraOptions.display.values;
    if (displayValues === 'labelWithCode') {
      rawLabel = `${item.label} (${item.code})`;
    } else {
      rawLabel = item[displayValues];
    }
  } else {
    rawLabel = item.label;
  }
  if (extraOptions && extraOptions.highlightText) {
    return highlightText(rawLabel, extraOptions.highlightText);
  }
  return rawLabel;
}
